// Module
var code = `<input type="text" ng-model="formattedAddress" name="location" ng-required="!doNotRequire" location-validation ng-focus="onFocus()" placeholder="{{placeholderText}}" ng-disabled="shouldDisable"><h5 ng-if="errorText">{{errorText}}</h5>`;
// Exports
export default code;